import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteProduct from 'hooks/product/useDeleteProduct';
import { ProductRetrieve } from 'types';
import notificationHandler from 'utils/notifications';

const ModalFeesAndMiscProductsDelete = ({
  opened,
  product,
  handleClose,
  handleClearCart,
}: {
  opened: boolean;
  handleClose: () => void;
  product: ProductRetrieve;
  handleClearCart: () => void;
}): JSX.Element => {
  const deleteFeeMiscMutation = useDeleteProduct();

  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    deleteFeeMiscMutation.mutate(product.productId, {
      onSuccess: () => {
        successNotification(
          'Fee or Miscellaneous product delete success',
          `${product.name} successfully deleted.`,
        );
        handleClearCart();
      },
      onError: error => {
        errorNotification('Fee or Miscellaneous product delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Product</Title>}
      size='md'
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${product.name}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={deleteFeeMiscMutation.isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalFeesAndMiscProductsDelete;
